module.exports = __webpack_public_path__ + "static/img/onozuka_06.8ad1031.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/onozuka_06.jpg
// module id = EeSc
// module chunks = 0